import { CartDropdownButton } from '#/components/CartDropdownButton/CartDropdownButton';
import { useABExperimentOrgDashboardCartRoute } from '#/modules/orgDashboard/hooks/useABExperimentOrgDashboardCartRoute';
import { postAListingRoute } from '#/routing/routes';
import { useUserEnvironmentCartDropdownButtonOrgsData } from '#/store/hooks/useUserEnvironmentCartDropdownButtonOrgsData';

export function CartDropdownButtonContainer() {
  const { orgsCartData } = useUserEnvironmentCartDropdownButtonOrgsData();
  const orgDashboardCartRoute = useABExperimentOrgDashboardCartRoute();

  const userHasAtLeastOneOrg = Boolean(orgsCartData?.length);
  if (!userHasAtLeastOneOrg) return null;

  return (
    <CartDropdownButton
      selectedOrgId={undefined}
      getOrgCartDataHref={(orgCartData) =>
        orgDashboardCartRoute.with({ orgId: orgCartData.id })
      }
      orgsCartData={orgsCartData ?? []}
      emptyHrefs={{
        postAJob: postAListingRoute.with({ listingType: 'JOB' }),
        postAnInternship: postAListingRoute.with({
          listingType: 'INTERNSHIP',
        }),
        postAVolop: postAListingRoute.with({ listingType: 'VOLOP' }),
        postAnEvent: postAListingRoute.with({ listingType: 'EVENT' }),
      }}
    />
  );
}
